import styled, { css } from 'styled-components';
import { i as isMobile } from '../../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { f as focusOutline } from '../../theme/style-mixins/FocusIndicator/focusOutline-oDdaDZ4N.js';
import { i as isDarkTheme } from '../../theme/style-mixins/isDarkTheme/isDarkTheme-DFKPsgi7.js';
import { i as isNotDarkTheme } from '../../theme/style-mixins/isDarkTheme/isNotDarkTheme-BpLwrzY3.js';
import { I as Icon } from '../../Icon/Icon-AcXbY_t4.js';

const InnerSwitchWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40027066__sc-jurnmj-0"
})(["position:relative;display:inline-flex;align-items:center;box-sizing:border-box;width:", ";height:", ";min-width:", ";min-height:", ";max-width:", ";max-height:", ";", ";:focus{outline:none;}"], ({
  theme,
  $size
}) => theme.switch.trackWidth[$size].default, ({
  theme,
  $size
}) => theme.switch.trackHeight[$size].default, ({
  theme,
  $size
}) => theme.switch.trackWidth[$size].default, ({
  theme,
  $size
}) => theme.switch.trackHeight[$size].default, ({
  theme,
  $size
}) => theme.switch.trackWidth[$size].default, ({
  theme,
  $size
}) => theme.switch.trackHeight[$size].default, isMobile(css(["width:", ";height:", ";min-width:", ";min-height:", ";max-width:", ";max-height:", ";"], ({
  theme,
  $size
}) => theme.switch.trackWidth[$size].mobile, ({
  theme,
  $size
}) => theme.switch.trackHeight[$size].mobile, ({
  theme,
  $size
}) => theme.switch.trackWidth[$size].mobile, ({
  theme,
  $size
}) => theme.switch.trackHeight[$size].mobile, ({
  theme,
  $size
}) => theme.switch.trackWidth[$size].mobile, ({
  theme,
  $size
}) => theme.switch.trackHeight[$size].mobile)));
const SliderButton = /*#__PURE__*/styled.button.withConfig({
  componentId: "sc-storm-ui-40027066__sc-jurnmj-1"
})(["position:absolute;cursor:", ";border-radius:", ";border:none;padding:", ";height:100%;width:100%;", ";", ";@media ( prefers-reduced-motion:no-preference){transition:color 100ms ease,background-color 100ms ease,border-color 100ms ease,box-shadow 100ms;}background-color:", ";&&:hover{background-color:", ";}&&:active{background-color:", ";}&&:disabled{background-color:", ";}", " :hover{::before{border:none;}}:focus-visible{", "}::before{position:absolute;content:\"\";inset-block-start:", ";inset-inline-start:", ";inset-inline-end:auto;box-sizing:border-box;transition-property:transform;", ";@media ( prefers-reduced-motion:no-preference){transition-duration:", ";}background:", ";border:none;border-radius:", ";height:", ";width:", ";/*! @noflip */ transform:translateX(", ");", ";}[dir=\"rtl\"] &&::before{/*! @noflip */ transform:translateX(-", ");", "}}"], ({
  disabled
}) => disabled ? 'not-allowed' : 'pointer', ({
  theme
}) => theme.border.radius.round, ({
  theme,
  $size
}) => theme.switch.padding[$size].default, isNotDarkTheme(css(["box-shadow:", ";"], ({
  theme
}) => theme.input.innerShadow)), isDarkTheme(css(["border:1px solid ", ";"], ({
  disabled,
  theme
}) => disabled ? theme.elevation.borderColor.subtle : 'transparent')), ({
  theme,
  $toggled
}) => $toggled ? theme.selectableWidget.backgroundColor.selected : theme.selectableWidget.backgroundColor.defaultInverted, ({
  theme
}) => theme.selectableWidget.backgroundColor.hover, ({
  theme
}) => theme.selectableWidget.backgroundColor.active, ({
  theme
}) => theme.selectableWidget.backgroundColor.unavailableInverted, isMobile(css(["padding:", ";"], ({
  theme,
  $size
}) => theme.switch.padding[$size].mobile)), focusOutline, ({
  theme,
  $size
}) => theme.switch.padding[$size].default, ({
  theme,
  $size
}) => theme.switch.padding[$size].default, isDarkTheme(css(["", ""], ({
  theme,
  $size
}) => css(["inset-block-start:calc(", " - 1px);inset-inline-start:calc(", " - 1px);"], theme.switch.padding[$size].default, theme.switch.padding[$size].default))), ({
  theme
}) => theme.switch.slideTransition, ({
  disabled,
  theme
}) => disabled ? theme.selectableWidget.shape.backgroundColor.inverted : theme.selectableWidget.shape.backgroundColor.default, ({
  theme
}) => theme.border.radius.round, ({
  theme,
  $size
}) => theme.switch.circleDiameter[$size].default, ({
  theme,
  $size
}) => theme.switch.circleDiameter[$size].default, ({
  theme,
  $toggled,
  $size
}) => $toggled ? theme.switch.slideTransitionX[$size].default : 0, isMobile(css(["height:", ";width:", ";inset-block-start:", ";inset-inline-start:", ";inset-inline-end:auto;", ";/*! @noflip */ transform:translateX(", ");"], ({
  theme,
  $size
}) => theme.switch.circleDiameter[$size].mobile, ({
  theme,
  $size
}) => theme.switch.circleDiameter[$size].mobile, ({
  theme,
  $size
}) => theme.switch.padding[$size].mobile, ({
  theme,
  $size
}) => theme.switch.padding[$size].mobile, isDarkTheme(css(["", ""], ({
  theme,
  $size
}) => css(["inset-block-start:calc(", " - 1px);inset-inline-start:calc(", " - 1px);"], theme.switch.padding[$size].mobile, theme.switch.padding[$size].mobile))), ({
  theme,
  $toggled,
  $size
}) => $toggled ? theme.switch.slideTransitionX[$size].mobile : 0)), ({
  theme,
  $toggled,
  $size
}) => $toggled ? theme.switch.slideTransitionX[$size].default : 0, isMobile(css(["/*! @noflip */ transform:translateX(-", ");"], ({
  theme,
  $toggled,
  $size
}) => $toggled ? theme.switch.slideTransitionX[$size].mobile : 0)));
const Checkmark = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-storm-ui-40027066__sc-jurnmj-2"
})(["visibility:", ";@media (prefers-reduced-motion:no-preference){transition:color 100ms ease,background-color 100ms ease,border-color 100ms ease,box-shadow 100ms,visibility 100ms;}justify-content:unset;display:flex;color:", ";svg{font-size:", ";", "}"], ({
  $toggled
}) => !$toggled ? 'hidden' : 'visible', ({
  $disabled,
  theme
}) => $disabled ? theme.selectableWidget.shape.backgroundColor.inverted : theme.selectableWidget.shape.backgroundColor.default, ({
  theme,
  $size
}) => theme.switch.iconDiameter[$size].default, isMobile(css(["font-size:", ";"], ({
  theme,
  $size
}) => theme.switch.iconDiameter[$size].mobile)));

export { Checkmark as C, InnerSwitchWrapper as I, SliderButton as S };
//# sourceMappingURL=InnerSwitch.styles-Nmnl-CHp.js.map
